import React from 'react';
import { CalendarIcon, InfoIcon } from 'lucide-react';
import { StatusBadge } from '../components/ui/StatusBadge';
const mockUpcomingExams = [{
  id: 'ESM-101',
  type: 'TAC torace',
  doctor: 'Dr. A. Neri',
  date: '2026-03-15',
  time: '10:30',
  status: 'Programmato',
  note: "Si prega di arrivare 15 minuti prima dell'appuntamento."
}, {
  id: 'ESM-102',
  type: 'Ecografia addome',
  doctor: 'Dr. M. Gialli',
  date: '2026-03-22',
  time: '14:00',
  status: 'Programmato',
  note: 'Presentarsi a digiuno da almeno 6 ore.'
}];
const mockCompletedNotReported = [{
  id: 'ESM-098',
  type: 'Radiografia torace',
  doctor: 'Dr. S. Verdi',
  date: '2026-03-08',
  time: '09:00',
  status: 'Da refertare'
}, {
  id: 'ESM-099',
  type: 'Risonanza magnetica ginocchio',
  doctor: 'Dr. A. Neri',
  date: '2026-03-05',
  time: '11:30',
  status: 'Da refertare'
}, {
  id: 'ESM-097',
  type: 'TAC encefalo',
  doctor: 'Dr. M. Gialli',
  date: '2026-03-01',
  time: '15:00',
  status: 'Da refertare'
}];
export function PatientExams() {
  return <div className="space-y-8 relative w-full min-w-0" data-id="element-1735">
      {/* Header */}
      <div data-id="element-1736">
        <h1 className="text-2xl md:text-page-title mb-1 md:mb-2 text-text-primary font-bold" data-id="element-1737">
          I miei esami
        </h1>
        <p className="text-sm md:text-body text-text-secondary" data-id="element-1738">
          Visualizza i tuoi esami programmati e in attesa di referto.
        </p>
      </div>

      {/* Upcoming Exams */}
      <section data-id="element-1739">
        <h2 className="text-xl md:text-section-title mb-4 text-text-primary font-semibold" data-id="element-1740">
          Prossimi esami
        </h2>

        {mockUpcomingExams.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-1741">
            {mockUpcomingExams.map(exam => <div key={exam.id} className="medical-card p-5 md:p-6 flex flex-col h-full" data-id="element-1742">
                <div className="flex items-start justify-between gap-4 mb-4" data-id="element-1743">
                  <div className="flex items-center gap-3" data-id="element-1744">
                    <div className="w-10 h-10 rounded-full bg-medical-orange-50 text-medical-orange flex items-center justify-center shrink-0" data-id="element-1745">
                      <CalendarIcon size={20} data-id="element-1746" />
                    </div>
                    <div data-id="element-1747">
                      <h3 className="text-base font-bold text-text-primary leading-tight" data-id="element-1748">
                        {exam.type}
                      </h3>
                      <p className="text-sm text-text-secondary mt-0.5" data-id="element-1749">
                        {exam.doctor}
                      </p>
                    </div>
                  </div>
                  <StatusBadge status={exam.status} data-id="element-1750" />
                </div>

                <div className="bg-clinical-gray-50 rounded-medical p-4 mt-auto" data-id="element-1751">
                  <div className="flex items-center gap-2 text-text-primary font-medium mb-2" data-id="element-1752">
                    <CalendarIcon size={16} className="text-text-secondary" data-id="element-1753" />
                    {exam.date} alle {exam.time}
                  </div>
                  {exam.note && <p className="text-xs text-text-secondary flex items-start gap-1.5" data-id="element-1754">
                      <InfoIcon size={14} className="shrink-0 mt-0.5 text-text-tertiary" data-id="element-1755" />
                      <span data-id="element-1756">{exam.note}</span>
                    </p>}
                </div>
              </div>)}
          </div> : <div className="medical-card p-10 md:p-12 flex flex-col items-center justify-center text-center" data-id="element-1757">
            <div className="w-14 h-14 rounded-full bg-clinical-gray-100 flex items-center justify-center mb-4" data-id="element-1758">
              <CalendarIcon size={28} className="text-text-tertiary" data-id="element-1759" />
            </div>
            <h3 className="text-base font-semibold text-text-primary mb-1" data-id="element-1760">
              Non hai esami programmati
            </h3>
            <p className="text-sm text-text-secondary max-w-sm" data-id="element-1761">
              Quando avrai nuovi esami prenotati, compariranno in questa
              sezione.
            </p>
          </div>}
      </section>

      {/* Pending Reports */}
      <section data-id="element-1762">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4" data-id="element-1763">
          <h2 className="text-xl md:text-section-title text-text-primary font-semibold" data-id="element-1764">
            Esami in attesa di referto
          </h2>
        </div>

        <div className="bg-status-info-bg border border-status-info/20 rounded-medical p-4 flex items-start gap-3 mb-4" data-id="element-1765">
          <InfoIcon className="text-status-info shrink-0 mt-0.5" size={20} data-id="element-1766" />
          <p className="text-sm text-text-secondary leading-relaxed" data-id="element-1767">
            Il referto sarà disponibile nella sezione "I miei referti" una volta
            completato dal medico.
          </p>
        </div>

        {mockCompletedNotReported.length > 0 ? <div className="space-y-3" data-id="element-1768">
            {mockCompletedNotReported.map(exam => <div key={exam.id} className="bg-white rounded-medical-lg shadow-card border border-clinical-gray-100 p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1769">
                <div className="min-w-0" data-id="element-1770">
                  <h3 className="text-sm font-bold text-text-primary mb-1 truncate" data-id="element-1771">
                    {exam.type}
                  </h3>
                  <p className="text-xs text-text-secondary truncate" data-id="element-1772">
                    Eseguito il {exam.date} alle {exam.time} • {exam.doctor}
                  </p>
                </div>
                <div className="shrink-0" data-id="element-1773">
                  <StatusBadge status={exam.status} data-id="element-1774" />
                </div>
              </div>)}
          </div> : <div className="medical-card p-10 md:p-12 flex flex-col items-center justify-center text-center" data-id="element-1775">
            <div className="w-14 h-14 rounded-full bg-clinical-gray-100 flex items-center justify-center mb-4" data-id="element-1776">
              <InfoIcon size={28} className="text-text-tertiary" data-id="element-1777" />
            </div>
            <h3 className="text-base font-semibold text-text-primary mb-1" data-id="element-1778">
              Non ci sono esami in attesa di refertazione
            </h3>
            <p className="text-sm text-text-secondary max-w-sm" data-id="element-1779">
              Tutti i tuoi esami sono stati refertati.
            </p>
          </div>}
      </section>
    </div>;
}